<div class="d-flex flex-wrap justify-content-between align-items-baseline">
    <mat-form-field appearance="outline" class="col-sm-6">
        <mat-label>Visualización de seguimientos</mat-label>
        <mat-select [formControl]="typeTrackingValue" (selectionChange)="onSelectionChange($event)">
            <mat-option *ngFor="let typeTracking of typesTracking" [value]="typeTracking">{{typeTracking}}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-sm-6">
        <mat-label>Ordenamiento</mat-label>
        <mat-select [formControl]="orderTrackingValue" (selectionChange)="onOrderSelectionChange($event)">
            <mat-option *ngFor="let orderOption of orderTrackingOptions"
                [value]="orderOption">{{orderOption}}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
<div *ngIf="!filteredHistoryNoveltyPoints?.length">
    No hay seguimientos registrados de tipo {{typeTrackingValue?.value?.toLowerCase()}} para este servicio
</div>